import { z } from 'zod';
import { CUISINE_OPTIONS, DIETARY_RESTRICTION_OPTIONS } from '../constants.js';

export const profileSchema = z.object({
  familySize: z.number().int().min(1).max(20),
  budget: z.number().positive().max(10000),
  dietaryRestrictions: z.array(
    z.string().max(100, 'Dietary restriction must be 100 characters or less')
  ),
  cuisinePreferences: z.array(z.enum(CUISINE_OPTIONS)),
  zipCode: z.string().regex(/^\d{5}$/, 'ZIP code must be 5 digits'),
}).strict();

export type ProfileInput = z.infer<typeof profileSchema>;
